<div #tabContainer>
<c11n-tabs  [activeItem]="viewType" (activeItemChange)="displayTable($event)" smallResponsiveBreakpoint="375"
            variant="left-aligned" overflowOption="nav-overflow" hasAnimation="true">
<c11n-tab-panel id="{{performance}}" labelText="{{fd3tableContentList.performance}}">
    <div class="c11n-text-crop">
      <performance-table [performanceCaas]="fd3tableContentList"></performance-table>
    </div>
  </c11n-tab-panel>
  <c11n-tab-panel id="{{fundLiterature}}" labelText="{{fd3tableContentList.fundLiterature}}">
    <div class="c11n-text-crop" *ngIf="isFundLiteratureDataAvailable">
      <fund-literature-table [literatureTableLabelCaas]="fd3tableContentList"></fund-literature-table>
    </div>
    <div class="c11n-text-crop" *ngIf="!isFundLiteratureDataAvailable && fundLiteratureContentServiceError">
      <no-data-page [noDataCaas]="isFundLiteratureNoData"></no-data-page>
    </div>
  </c11n-tab-panel>
</c11n-tabs>
</div>
